import React from "react";
import { Input } from "react-toolbox/lib/input";
import syncingInput from "components/syncingInput";
import styles from "components/InputSync.css";

const SyncingInput = syncingInput(Input);

const InputSync = ({ inputTheme, ...props }) => (
  <SyncingInput inputTheme={inputTheme || styles} {...props} />
);

export default InputSync;
